// @flow strict
import * as React from 'react';

import { LinkContainer } from 'components/graylog/router';
import { DocumentTitle, PageHeader } from 'components/common';
import { Button } from 'components/graylog';
import UserOverviewLinks from 'components/users/navigation/UserOverviewLinks';
import Routes from 'routing/Routes';

import TeamCreate from '../components/team-create/TeamCreate';

const TeamCreatePage = () => (
  <DocumentTitle title="Team Create">
    <PageHeader title="Team Create"
                subactions={(
                  <LinkContainer to={Routes.pluginRoute('SYSTEM_TEAMS_NEW')}>
                    <Button bsStyle="success">
                      Create Team
                    </Button>
                  </LinkContainer>
                )}>
      <span>
        Create new team and assign users.
      </span>

      {/* TODO: Add documentation link once we have documentation */}
      <span />

      <UserOverviewLinks />
    </PageHeader>

    <TeamCreate />

  </DocumentTitle>
);

export default TeamCreatePage;
